// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'desktop-solid';

export const Component = () => (
  <path d='M23.037 1H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 2.485v16.667c0 .43.144.766.431 1.053.288.288.623.432 1.054.432h21.552c.431 0 .766-.144 1.054-.432.287-.287.43-.622.43-1.053V2.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 23.037 1Zm.526 1.484v13.22H.958V2.483c0-.335.191-.526.526-.526h21.552c.335 0 .526.191.526.526h.001Zm-6.418 21.074c.335 0 .527.144.527.479 0 .335-.192.479-.527.479h-9.77c-.335 0-.527-.144-.527-.48 0-.334.192-.478.527-.478h1.628l.431-1.963h5.652l.431 1.963h1.628Z' />
);

export const viewBox = '0 0 25 25';
